<!--
  author：Zoufx
  description：角色
  date：2020/9/3
-->
<template>
  <div class="table_container">
    <el-row style="margin-bottom:10px">
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd" size="medium">新建</el-button>
    </el-row>
    <el-row>
      <el-table highlight-current-row :data="tableData" v-loading="$store.state.loading">
        <el-table-column min-width="100" prop="roleName" label="角色名" align="center"/>
        <el-table-column min-width="100" prop="code" label="编码" align="center"/>
        <el-table-column min-width="100" prop="level" label="级别" align="center"/>
        <el-table-column min-width="100" prop="remarks" label="备注" align="center"/>
        <el-table-column min-width="200" label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip :open-delay="700" effect="light" content="修改" placement="top">
              <el-button type="success" @click="handleEdit(scope.$index, scope.row)"
                         icon="el-icon-edit" size="mini"/>
            </el-tooltip>
            <el-tooltip :open-delay="700" effect="light" content="删除" placement="top">
              <el-button type="danger" @click="handleDelete(scope.$index, scope.row)"
                         icon="el-icon-delete" size="mini"/>
            </el-tooltip>
            <el-tooltip :open-delay="700" effect="light" content="授权" placement="top">
              <el-button type="warning" @click="handlePermission(scope.$index, scope.row)"
                         icon="el-icon-sort" size="mini"/>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="table_pagination">
      <el-pagination background :pageCount="pageCount" :currentPage="currentPage" :page-size="pageSize"
                     layout="prev, pager, next" @current-change="handleCurPageChange"
                     hide-on-single-page/>
    </el-row>
    <sys-role-form :formVisible.sync="formVisible" :selRow="selRow" :submitUrl="submitUrl"
                   @refreshList="getTableData"/>
    <sys-role-permission :permissionVisible.sync="permissionVisible" :treeData="treeData" :treeDataNoChildrenIds="treeDataNoChildrenIds" :selRow="selRow"
                         @refreshList="getTableData"/>
  </div>
</template>

<script>
  import SysRoleForm from "./form/SysRoleForm";
  import SysRolePermission from './form/SysRolePermission'
  import {commonListMixin} from "../../utils/commonListMixin";

  export default {
    name: 'SysRoleIndex',
    components: {SysRoleForm, SysRolePermission},
    mixins: [commonListMixin],
    data() {
      return {
        treeData: [],
        treeDataNoChildrenIds: [],
        url: {
          list: '/sysRole/findList',
          add: '/sysRole/save',
          edit: '/sysRole/update',
          delete: '/sysRole/delete'
        },
        permissionVisible: false
      }
    },
    async mounted() {
      await this.getTreeData();
      this.makeNoChildrenIds(this.treeData)
    },
    methods: {
      async getTreeData() {
        let params = {};
        let {obj} = await this.postRequest('/sysMenu/findTree', params);
        this.treeData = obj;
      },
      makeNoChildrenIds(treeData) {
        treeData.forEach(ele => {
          if (ele.children && ele.children != 'null' && ele.children.length > 0) {
            this.makeNoChildrenIds(ele.children)
          } else {
            this.treeDataNoChildrenIds.push(ele.id);
          }
        });
      },
      handlePermission(index, row) {
        this.selRow = row;
        this.permissionVisible = true
      }
    }
  }
</script>
<style scoped>

</style>
